import { defineProtocolIdSetStore } from './protocol-id-set';

/** Ids of protocols seen as self-coached by the current user. */
export const useSelfCoachedProtocols = defineProtocolIdSetStore('selfCoachedProtocols');
